import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import { useAuth } from '@clerk/clerk-react';
import { GET_LIVE_LANGUAGE_STATUS_QUERY_KEY } from '@/state/queries/player/use-live-language-status';

export const useClearLiveCaptionsMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: { entityRef: string }) => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/player/live-context-state/live-language/clear`;
      return sendJSONRequest({ url, method: METHOD.POST, body, token: token ?? '' });
    },
    onSuccess: (_, variables) => {
      void queryClient.invalidateQueries({ queryKey: [GET_LIVE_LANGUAGE_STATUS_QUERY_KEY, variables.entityRef] });
    },
  });
};
